export const TEXT_CASE = {
  UPPERCASE: "UPPERCASE",
  LOWERCASE: "LOWERCASE",
  CAPITALIZE: "CAPITALIZE",
  TITLES: "TITLES",
};

export const DEVICE_TYPES = {
  ANDROID: 'android',
  IOS: 'ios',
  WEB: 'web',
};